import { render, staticRenderFns } from "./t-chart.vue?vue&type=template&id=315d6ec8&scoped=true&"
import script from "./t-chart.vue?vue&type=script&lang=js&"
export * from "./t-chart.vue?vue&type=script&lang=js&"
import style0 from "./t-chart.vue?vue&type=style&index=0&id=315d6ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d6ec8",
  null
  
)

export default component.exports